import { AnimatedSprite, Container, Graphics, LINE_CAP, LINE_JOIN, Sprite } from 'pixi.js';
import { TextureFactory } from '../core';
import PlayerTextureInfo from '../class/running/Player.json';

class RunningGameProgress extends Container {
  private line: Graphics;
  private flag: Sprite;
  private ninimo: AnimatedSprite;
  private stageWidth: number = 0;
  private stageHeight: number = 0;

  constructor() {
    super();

    this.line = new Graphics();
    this.addChild(this.line);

    this.flag = new Sprite(TextureFactory.instance.getSingleTexture('/textures/ui/flag.png'));
    this.flag.scale.set(0.2);
    this.flag.anchor.set(0.5, 1.1);
    this.addChild(this.flag);

    const textures = TextureFactory.instance.load(PlayerTextureInfo);
    this.ninimo = new AnimatedSprite(textures.slice(0, 12));
    this.ninimo.scale.set(0.2);
    this.ninimo.animationSpeed = 0.4;
    this.ninimo.play();

    this.addChild(this.ninimo);
  }

  public update(width: number, height: number, progress: number): void {
    if (progress >= 1) progress = 1;

    if (this.stageWidth !== width || this.stageHeight !== height) {
      this.stageWidth = width;
      this.stageHeight = height;
      this.redraw();
    }

    const padding = 40;
    this.ninimo.y = this.stageHeight - padding;
    this.ninimo.x = padding + (this.stageWidth - padding * 2) * progress;
  }

  private redraw(): void {
    const padding: number = 40;

    this.line.clear();

    this.line.beginFill(0x555555, 0.5);
    this.line.drawRoundedRect(5, this.stageHeight - padding - 40, this.stageWidth - 10, 60, 10);
    this.line.endFill();

    this.line.lineStyle({
      width: 4,
      color: 0x475153,
      cap: LINE_CAP.ROUND,
      join: LINE_JOIN.ROUND,
    });
    this.line.moveTo(padding, this.stageHeight - padding);
    this.line.lineTo(this.stageWidth - padding, this.stageHeight - padding);

    this.flag.x = this.stageWidth - padding;
    this.flag.y = this.stageHeight - padding;
  }
}

export default RunningGameProgress;
